import { DashboardPage } from 'foundations-components/transitional/components/DashboardPage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ErrorBoundary } from '../components/ErrorBoundary';
import { SearchResultsPageHeader } from '../components/headers/SearchResultsPageHeader';
import { Paths } from '../constants/paths';
import { StorefrontFilterBar } from '../filters/components/StorefrontFilterBar';
import { useFilterDefinitionsQuery } from '../filters/hooks/useFilterDefinitionsQuery';
import { KEY_PREFIX } from '../hooks/useSearchParams';
import { OtherCollections } from './components/OtherCollections';
import { ResultsGrid } from './components/ResultsGrid';
import { SearchResultsHeader } from './components/SearchResultsHeader';
import { SearchResultsPaginator } from './components/SearchResultsPaginator';
import { useCollectionQuery } from './hooks/useCollectionQuery';
import { parseSearchResultsPath } from './utils/parseSearchResultsPath';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SearchResultsPage() {
  const location = useLocation();
  const collectionResult = useCollectionQuery();
  const parsedPath = useMemo(() => parseSearchResultsPath(location.pathname), [location.pathname]);

  // this means we came from an SEO-optimized URL and need to redirect
  if (Object.keys(parsedPath).length > 0) {
    return /*#__PURE__*/_jsx(ConvertedPathRedirector, {
      parsedPath: parsedPath
    });
  }
  if (collectionResult.loading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      size: "medium",
      marginBlockStart: "1600"
    });
  }
  if (collectionResult.error) {
    return /*#__PURE__*/_jsx(ErrorMessage, {
      type: "badRequest"
    });
  }
  return /*#__PURE__*/_jsx(DashboardPage, {
    headerComponent: /*#__PURE__*/_jsx(SearchResultsPageHeader, {}),
    children: /*#__PURE__*/_jsxs(ErrorBoundary, {
      children: [/*#__PURE__*/_jsx(SearchResultsHeader, {}), /*#__PURE__*/_jsx(StorefrontFilterBar, {}), /*#__PURE__*/_jsx(ResultsGrid, {}), /*#__PURE__*/_jsx(SearchResultsPaginator, {}), collectionResult.data && /*#__PURE__*/_jsx(OtherCollections, {})]
    })
  });
}

/** This is rendered when the URL is SEO-optimized, such as `/explore/apps/abm`.
 * The user is immediately redirected to the query-param version of the URL. */
function ConvertedPathRedirector({
  parsedPath
}) {
  const history = useHistory();
  const {
    data
  } = useFilterDefinitionsQuery();
  useEffect(() => {
    if (!data) return;
    if (Object.keys(parsedPath).length === 0) return;
    const urlParams = new URLSearchParams();
    if (parsedPath.productType) urlParams.set(`${KEY_PREFIX}PRODUCT_TYPE`, parsedPath.productType);
    if (parsedPath.page) urlParams.set(`${KEY_PREFIX}page`, parsedPath.page.toString());
    if (parsedPath.categorySlug) {
      var _data$result$filtersB;
      // we need to convert from the category's slug to its enum value
      const categoryEnumValue = (_data$result$filtersB = data.result.filtersByProductType['APP'].find(f => f.baseQueryField === 'CATEGORY')) === null || _data$result$filtersB === void 0 || (_data$result$filtersB = _data$result$filtersB.options.find(o => o.slug === parsedPath.categorySlug)) === null || _data$result$filtersB === void 0 ? void 0 : _data$result$filtersB.value;
      if (categoryEnumValue) urlParams.set(`${KEY_PREFIX}CATEGORY`, categoryEnumValue);
    }
    history.replace(`${Paths.SEARCH_RESULTS}?${urlParams.toString()}`);
  }, [parsedPath, history, data]);
  return /*#__PURE__*/_jsx(LoadingSpinner, {
    grow: true,
    size: "medium",
    marginBlockStart: "1600"
  });
}